import {
  solarSeals,
  getSealColorClass,
  getSealTextColor,
  getSealImageUrl,
  getSealBorderClass,
  getSealBgClass,
} from "@/mocks/dreamspellData";

export default function SolarSeals() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 animate-fade-in">
      <div className="max-w-5xl mx-auto text-center">
        <div className="text-xs text-stone-500 uppercase tracking-widest mb-2">
          SOLAR SEALS
        </div>
        <h2 className="text-xl md:text-2xl font-bold text-stone-800 mb-3">
          20 太陽印記總覽
        </h2>
        <p className="text-sm text-stone-600 leading-relaxed mb-8 max-w-2xl mx-auto">
          Dreamspell 將二十個太陽印記循環排列，依
          <span className="text-red-600 font-medium"> 紅 </span>·
          <span className="text-stone-400 font-medium"> 白 </span>·
          <span className="text-sky-600 font-medium"> 藍 </span>·
          <span className="text-amber-600 font-medium"> 黃 </span>
          四色族群推進。每一個印記都帶著一組關鍵字與成長方向。
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {solarSeals.map((seal) => {
            const imageUrl = getSealImageUrl(seal.id);
            return (
              <div
                key={seal.id}
                className={`border rounded-xl overflow-hidden ${getSealBorderClass(seal.color)} ${getSealBgClass(seal.color)} hover:bg-white transition-colors`}
              >
                {imageUrl && (
                  <div className="flex justify-center pt-4 px-4">
                    <img
                      src={imageUrl}
                      alt={seal.name}
                      className="w-24 h-24 md:w-28 md:h-28 rounded-lg object-cover"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="p-4 pt-3 text-center">
                  <div className="text-xs text-stone-400 uppercase tracking-wider mb-2">
                    {String(seal.id).padStart(2, "0")} · {seal.color.toUpperCase()}
                  </div>
                  <div className="flex items-center justify-center gap-2 mb-1">
                    <span
                      className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${getSealColorClass(seal.color)}`}
                    />
                    <span
                      className={`font-semibold text-base ${getSealTextColor(seal.color)}`}
                    >
                      {seal.name}
                    </span>
                  </div>
                  <div className="text-xs text-stone-400 mb-2">
                    {seal.englishName}
                  </div>
                  <div className="text-xs text-stone-500 leading-relaxed">
                    {seal.keywords}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}